import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section id="contact" className="py-24 bg-gradient-to-br from-amber-400 via-amber-500 to-amber-600 relative overflow-hidden">
      {/* Elegant background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-40 h-40 border border-white rounded-full"></div>
        <div className="absolute bottom-20 right-20 w-32 h-32 border border-white rounded-full"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-24 h-24 border border-white rounded-full"></div>
      </div>

      {/* Subtle overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/10 to-black/5"></div>

      <div className="max-w-6xl mx-auto px-8 text-center relative z-10">
        {/* Section Header */}
        <div className="mb-16">
          <div className="inline-flex items-center mb-8">
            <div className="w-20 h-px bg-white/60"></div>
            <span 
              className="mx-8 text-white/90 text-sm tracking-[0.3em] font-light uppercase"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              Contact Us
            </span>
            <div className="w-20 h-px bg-white/60"></div>
          </div>
          
          <h2 
            className="text-5xl md:text-6xl font-light text-white mb-8 tracking-wide"
            style={{ 
              fontFamily: '"Noto Serif JP", serif',
              letterSpacing: '0.02em',
              textShadow: '0 2px 10px rgba(0,0,0,0.2)'
            }}
          >
            お気軽にお問い合わせください
          </h2>
          
          <p 
            className="text-xl md:text-2xl text-white/90 font-light max-w-6xl mx-auto leading-relaxed"
            style={{ 
              fontFamily: '"Noto Sans JP", sans-serif',
              lineHeight: '1.8'
            }}
          >
            サービスに関するご質問、研修のご依頼など、<br />
            執事ベルが心を込めてご対応いたします。<br />
            <span className="text-lg text-white/80 mt-4 block">
              一流のおもてなしで、あなたの特別な瞬間をお手伝いします
            </span>
          </p>
        </div>

        {/* Contact Methods */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {/* Email */}
          <div className="group bg-white/10 backdrop-blur-sm border border-white/20 p-8 hover:bg-white/20 transition-all duration-500">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-500">
              <i className="ri-mail-line text-2xl text-white"></i>
            </div>
            <h3 
              className="text-xl font-light text-white mb-4"
              style={{ fontFamily: '"Noto Serif JP", serif' }}
            >
              メールでのお問い合わせ
            </h3>
            <p 
              className="text-white/80 font-light"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              info@butlerbell.jp
            </p>
          </div>

          {/* Location */}
          <div className="group bg-white/10 backdrop-blur-sm border border-white/20 p-8 hover:bg-white/20 transition-all duration-500">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-500">
              <i className="ri-map-pin-line text-2xl text-white"></i>
            </div>
            <h3 
              className="text-xl font-light text-white mb-4"
              style={{ fontFamily: '"Noto Serif JP", serif' }}
            >
              事務所所在地
            </h3>
            <p 
              className="text-white/80 font-light leading-relaxed"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              〒135-0064<br />
              東京都江東区青海2丁目7−4
            </p>
          </div>

          {/* Phone */}
          <div className="group bg-white/10 backdrop-blur-sm border border-white/20 p-8 hover:bg-white/20 transition-all duration-500">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-500">
              <i className="ri-phone-line text-2xl text-white"></i>
            </div>
            <h3 
              className="text-xl font-light text-white mb-4"
              style={{ fontFamily: '"Noto Serif JP", serif' }}
            >
              お電話でのお問い合わせ
            </h3>
            <p 
              className="text-white/80 font-light text-sm"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              お問い合わせフォームより<br />ご連絡ください
            </p>
          </div>
        </div>

        {/* Main CTA Button */}
        <div className="flex justify-center">
          <Link
            to="/contact"
            className="btn-gold group relative bg-white text-amber-600 hover:bg-gray-100 px-16 py-5 font-light text-xl transition-all duration-500 transform hover:scale-105 overflow-hidden shadow-2xl whitespace-nowrap"
            style={{ 
              fontFamily: '"Noto Sans JP", sans-serif',
              letterSpacing: '0.1em'
            }}
          >
            <span className="relative z-10 mr-4">お問い合わせフォームへ</span>
            <i className="ri-arrow-right-line relative z-10 text-2xl group-hover:translate-x-2 transition-transform duration-300"></i>
            
            {/* Hover effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-gray-50 to-gray-100 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
            
            {/* Decorative shine */}
            <div className="absolute inset-0 bg-white/30 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
          </Link>
        </div>

        {/* Additional note */}
        <div className="mt-12">
          <p 
            className="text-white/70 text-sm font-light"
            style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
          >
            ※ 24時間以内にご返信いたします。お急ぎの場合は、お問い合わせフォームにその旨をご記載ください。
          </p>
        </div>
      </div>

      {/* Decorative corner elements */}
      <div className="absolute top-0 left-0 w-32 h-32 border-l-2 border-t-2 border-white/30"></div>
      <div className="absolute top-0 right-0 w-32 h-32 border-r-2 border-t-2 border-white/30"></div>
      <div className="absolute bottom-0 left-0 w-32 h-32 border-l-2 border-b-2 border-white/30"></div>
      <div className="absolute bottom-0 right-0 w-32 h-32 border-r-2 border-b-2 border-white/30"></div>
    </section>
  );
}
